import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

// Shared by every agent-detail tab: resolve the brain from the route and
// (re-)fetch it on mount so deep links work.
export function useBrain() {
  const route = useRoute();
  const store = useStore();

  const brainId = computed(() => route.params.brainId);
  const brain = computed(() =>
    store.getters['aiAgentBrains/getRecord'](brainId.value)
  );

  const fetchBrain = () => store.dispatch('aiAgentBrains/show', brainId.value);

  onMounted(fetchBrain);

  return { brainId, brain, fetchBrain };
}
